// Mirrors the API's AdvanceShareStyleType enum (Elites.Service.Dtos/AdvanceShareModels/AdvanceShare.cs).
export const AdvanceShareStyleTypeList = [
  { value: 1, label: 'GlowingPathBehindAthlete' },
  { value: 2, label: 'PathIntoAthlete' },
  { value: 3, label: 'ActionInfographicSplit' },
  { value: 4, label: 'HeroicAuraTrackWatermark' },
  { value: 5, label: 'LuminousGroundTrailMarkers' },
  { value: 6, label: 'FreshChalkFinishLineArt' },
  { value: 7, label: 'LowAngleGiantPerspectiveMap' },
  { value: 8, label: 'RealisticGroundTrailEdit' },
  { value: 9, label: 'MonsterCanEnergyPourExplosion' },
  { value: 10, label: 'ShoeAfterburnerLeap' },
  { value: 11, label: 'GiantIPhoneNeonEscape' },
  { value: 12, label: 'OutdoorTrack' },
  { value: 13, label: 'GiantSneaker' },
  { value: 14, label: 'DrinkCan' },
  { value: 15, label: 'Lego' },
  { value: 16, label: 'Sunglasses' },
  { value: 17, label: 'ShoeOutsole' },
  { value: 18, label: 'SculpturalBust' },
  { value: 19, label: 'Silhouette' },
  { value: 20, label: 'EnergyRing' },
  { value: 21, label: 'BackOnAsphalt' },
  { value: 22, label: 'GlowingCrown' },
  { value: 23, label: 'Parachute' },
  { value: 24, label: 'Dragon' },
  { value: 25, label: 'BackToThePace' },
  { value: 26, label: 'DarkMoodyEnvironment' },
  { value: 27, label: 'ChibiStickers' },
  { value: 28, label: 'SitInsideShoe' },
  { value: 29, label: 'ColorfulSmoke' },
  { value: 30, label: 'ShoeFieryEffect' },
  { value: 31, label: 'CctvSurveillance' },
  { value: 32, label: 'NeonGreenHudPortrait' },
  { value: 33, label: 'ExplosiveSprint' },
  { value: 34, label: 'FisheyeStreetRun' },
  { value: 35, label: 'TinyPlanet' },
  { value: 36, label: 'KawaiiPapercraft' },
  { value: 37, label: 'WatercolorFashion' },
  { value: 38, label: 'StormEnergyRing' },
  { value: 39, label: 'OversizedSneakerAd' },
  { value: 40, label: 'PapercraftPortrait' },
  { value: 41, label: 'ColoredPencilCaricature' },
  { value: 42, label: 'MarbleBust' },
  { value: 43, label: 'ScrapbookDoodle' },
  { value: 44, label: 'BackToRunningPoster' },
  { value: 45, label: 'AnimeSportsPoster' },
  { value: 46, label: 'LongRunSundayFrame' },
  { value: 47, label: 'WatchHologram' },
  { value: 48, label: 'TradingCardRunner' },
  { value: 49, label: 'EnamelMagnetSouvenir' },
  { value: 50, label: 'GiantMedalImpact' },
  { value: 51, label: 'ThermalInfraredSurveillance' },
  { value: 52, label: 'StyleizedCaricature3D' },
  { value: 53, label: 'MotionCaptureMultiExposure' },
  { value: 54, label: 'VogueFashionIllustration' },
  { value: 55, label: 'SmartWatchDisplay' },
  { value: 56, label: 'CinematicRunningPoster' },
  { value: 57, label: 'SoloWorldcup' },
  { value: 58, label: 'GraffitiMuralWorldcup' },
  { value: 59, label: 'NeonEnergyLightTrails' },
  { value: 60, label: 'SuperhumanSpeedRunner' },
  { value: 61, label: 'CinematicSilhouetteRunner' },
  { value: 62, label: 'ElitesMagazineCover1' },
  { value: 63, label: 'ElitesMagazineCover2' },
  { value: 64, label: 'ElitesMagazineCover3' },
  { value: 65, label: 'ElitesMagazineCover4' },
  { value: 66, label: 'ElitesMagazineCover5' },
  { value: 67, label: 'ElitesMagazineCover6' },
  { value: 68, label: 'ElitesMagazineCover7' },
  { value: 69, label: 'ElitesMagazineCover8' },
  { value: 70, label: 'ChampionshipCelebrationPortrait' },
  { value: 71, label: 'DoubleExposureRunner' },
  { value: 72, label: 'CinematicJerseyHud' },
  { value: 73, label: 'AbstractPaintedStride' },
  { value: 74, label: 'PremiumTradingCard' },
  { value: 75, label: 'ComicBookChampionshipPoster' },
  { value: 76, label: 'ChampionshipCultureWallPoster' },
  { value: 77, label: 'CelebrationDoubleExposureHud' },
];
